/**
 * Validates if a phone number is a valid US phone number in allowed formats
 * @param phoneNumber - The phone number string or number to validate
 * @returns boolean - True if valid US phone number, false otherwise
 */
export const isValidUSPhone = (phoneNumber: string | number): boolean => {
  // Convert to string if it's a number
  const phoneString = String(phoneNumber);
  
  // Remove all non-digit characters
  const digitsOnly = phoneString.replace(/\D/g, '');
  
  // Must be exactly 10 or 11 digits
  if (digitsOnly.length !== 10 && digitsOnly.length !== 11) {
    return false;
  }
  
  // If 11 digits, must start with 1 (country code)
  if (digitsOnly.length === 11 && !digitsOnly.startsWith('1')) {
    return false;
  }
  
  // Get the area code (first 3 digits after country code)
  const areaCodeStartIndex = digitsOnly.length === 11 ? 1 : 0;
  const areaCode = digitsOnly.substring(areaCodeStartIndex, areaCodeStartIndex + 3);
  
  // Area code must start with 2-9 (NANP standard)
  return /^[2-9]/.test(areaCode);
}; 